const messages = {
    accountBox: {
        title: "Tableau de bord",
        description: "Accédez en un clin d'œil au suivi de vos animations et de vos points",
        button: "ACCÉDER AU TABLEAU DE BORD",
    },
};

export default {
    messages,
};
